import { render, staticRenderFns } from "./SQLsErpIntegracao.vue?vue&type=template&id=355ea0c1"
import script from "./SQLsErpIntegracao.vue?vue&type=script&lang=js"
export * from "./SQLsErpIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports